import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { crmService } from '../data-services';
import style from './TicketEventPage.module.css';
import dinoLogo from '../img/dino-logo.png';
import creepers from '../img/creepers.png';
import liqpayImage from '../img/liqupay.png';
import cardsImage from "../img/pngwing.com.png";
import contactCreeperImage from "../img/contact-creeper.png";



const TicketEventPage = () => {

    const paymentType = 'LiqPay';

    const handleScrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className={style.ticketPage}>
            <header className={style.header}>
                <div className={style.infoHeader}>
                    <div className={style.headersLocationName}>DINOWORLD</div>
                    <img src={dinoLogo} alt="dyno-logo" className={style.logoImage} />
                </div>
            </header>
            <img src={creepers} alt="dyno-logo" className={style.creepersImage} />
            <div className={style.rulesBlock}>
                <h2> {paymentType === 'LiqPay' ? 'Інфо' : 'Info'}
                </h2>
                <div id="about-us" className={style.ruleSection}>
                    <h3 className={style.ruleHeader}>
                        {paymentType === 'LiqPay' ? 'Хто веде підприємницьку діяльність' : 'About Us'}
                    </h3>
                    <div className={style.ruleContent}>
                        Продаж квитків для відвідування парку атракціонів DINOWORLD здійснює
                        ФОП ГАЩАК ТЕТЯНА СЕРГІЇВНА (Київ, Броварський проспект 1, dinoparkkyiv@gmail.com)
                    </div>
                </div>

                <div id="payment-rules" className={style.ruleSection}>
                    <h3 className={style.ruleHeader}>
                        {paymentType === 'LiqPay' ? '2. Умови і правила Оплати' : 'Rules for Payment'}
                    </h3>
                    <div className={style.ruleContent}>
                        <p>2.1. Квитки на заходи можна придбати через офіційний сайт Організатора, а також через уповноважені агентства та партнерів.</p>
                        <p>2.2. Для придбання квитка Покупець повинен зареєструватися на сайті Організатора, вказавши необхідні персональні дані.</p>
                        <p>2.3. Оплата квитка здійснюється банківською карткою або іншим способом, доступним на сайті Організатора.</p>
                        <p>2.4. Після успішної оплати квитка, Покупець отримує електронний квиток на вказану ним адресу електронної пошти. Електронний квиток містить унікальний QR-код, необхідний для входу на захід.</p>
                        <p>2.5. Організатор не несе відповідальності за дії третіх осіб, які можуть перешкоджати здійсненню придбання квитка, зокрема за збої в роботі банківських систем або інтернет-сервісів.</p>
                    </div>
                </div>

                <div id="delivery-rules" className={style.ruleSection}>
                    <h3 className={style.ruleHeader}>
                        {paymentType === 'LiqPay' ? '3. Умови і правила Доставки\n' : 'Rules for Delivery'}
                    </h3>
                    <div className={style.ruleContent}>
                        <p>3.1. Організатор не надає послуг офлайн доставки квитків (через пошту, кур'єрські служби тощо).</p>
                        <p> 3.2. Усі квитки на заходи надсилаються Покупцеві в електронному вигляді на вказану ним адресу електронної пошти під час придбання квитка.</p>
                        <p>3.3. Електронний квиток містить унікальний QR-код, необхідний для входу на захід. Покупець може роздрукувати квиток або пред'явити його на своєму мобільному пристрої.</p>
                        <p>3.4. Разом з електронним квитком Покупець отримує доступ до особистого кабінету на сайті Організатора. В листі, що надсилається на електронну пошту Покупця, містяться логін, пароль та посилання на особистий кабінет.</p>
                        <p>3.5. У особистому кабінеті Покупець може переглянути, завантажити або роздрукувати свій квиток у будь-який зручний для нього час.</p>

                    </div>
                </div>

                <div id="refund-policy" className={style.ruleSection}>
                    <h3 className={style.ruleHeader}>
                        {paymentType === 'LiqPay' ? '4. Умови і правила повернення коштів' : 'Refund Policy'}
                    </h3>
                    <div className={style.ruleContent}>
                        <p>4.1. Організатор надає можливість повернення коштів за придбані квитки лише за умови, що Покупець зв'яжеться з Організатором за телефоном <a href={"tel:+380504489303"} style={{color: 'black', fontWeight: 'normal'}}> 380504489303 </a> або надішле електронного листа на <a href={"email:dinoparkkyiv@gmail.com"} style={{color: 'black',  fontWeight: 'normal'}}> dinoparkkyiv@gmail.com </a>.</p>
                        <p>4.2. Повернення коштів здійснюється лише до дати та часу заходу, зазначених на квитку. Після настання дати і часу заходу, повернення коштів не здійснюється.</p>
                        <p>4.3. Усі питання, пов'язані з помилковими покупками, проблемами з оплатою або роботою сайту та електронної системи придбання квитків, також можуть бути вирішені через службу підтримки Організатора.</p>

                    </div>
                </div>

                <div id="confidentiality-rules" className={style.ruleSection}>
                    <h3 className={style.ruleHeader}>
                        {paymentType === 'LiqPay' ? '5. Умови Конфіденційності даних клієнта' : 'Rules for Confidential clients data'}
                    </h3>
                    <div className={style.ruleContent}>
                        <p>5.1. Організатор зобов'язується дотримуватися конфіденційності персональних даних Покупця відповідно до законодавства України.</p>
                        <p> 5.2. Персональні дані Покупця використовуються виключно для цілей виконання цих Умов і можуть бути передані третім особам тільки у випадках, передбачених законом.</p>
                        <p>5.3. Організатор збирає і зберігає тільки ті персональні дані, які надає Клієнт під час придбання квитка, а саме: ім'я власника квитка та імейл.</p>
                        <p>5.4. Організатор використовує Google Analytics для збору анонімних даних про відвідування Сайту з метою поліпшення його роботи та якості обслуговування Клієнтів.</p>
                        <p>5.5. Усі платежі за квитки здійснюються через еквайрінгову компанію LiqPay, яка забезпечує безпеку платіжних даних Клієнта.</p>
                        <p> 5.6. Організатор зобов'язується забезпечити належний рівень захисту персональних даних Клієнта від несанкціонованого доступу, розголошення або знищення.</p>
                        <p>5.7. Організатор використовує сучасні технології безпеки для захисту персональних даних, що відповідають міжнародним стандартам захисту даних.</p>

                    </div>
                </div>
                <div id="lawyers-client" className={style.ruleSection}>
                    <h3 className={style.ruleHeader}>
                        {paymentType === 'LiqPay' ? '6. Права Клієнта' : 'Lawyers'}
                    </h3>
                    <div className={style.ruleContent}>
                        <p>6.1. Клієнт має право на доступ до своїх персональних даних, їх виправлення або видалення, а також право обмежити або заперечувати проти їх обробки відповідно до положень GDPR.</p>
                        <p>6.2. Клієнт може реалізувати свої права, звернувшись до служби підтримки Організатора за електронною адресою <a href={"email:dinoparkkyiv@gmail.com"} style={{color: 'black',  fontWeight: 'normal'}}> dinoparkkyiv@gmail.com </a> або за телефоном <a href={"tel:+380504489303"} style={{color: 'black',  fontWeight: 'normal'}}> 380504489303 </a>.</p>
                    </div>
                </div>
                <div id="others" className={style.ruleSection}>
                    <h3 className={style.ruleHeader}>
                        {paymentType === 'LiqPay' ? '7. Інші умови' : 'Others'}
                    </h3>
                    <div className={style.ruleContent}>
                        <p>7.1. Усі суперечки та розбіжності, що виникають у зв'язку з виконанням цих Умов, вирішуються шляхом переговорів. У разі недосягнення згоди, суперечка передається на розгляд до відповідного суду за місцем знаходження Організатора.</p>
                        <p> 7.2. Ці Умови можуть бути змінені Організатором в односторонньому порядку. Зміни набирають чинності з моменту їх публікації на офіційному сайті Організатора.</p>
                        <p>7.3. Недійсність окремого положення цих Умов не впливає на дійсність інших положень.</p>
                        <p>7.4. У разі виникнення питань або побажань щодо цих Умов, Клієнт може звернутися до служби підтримки Організатора за електронною адресою <a href={"email:dinoparkkyiv@gmail.com"}  style={{color: 'black',  fontWeight: 'normal'}}> dinoparkkyiv@gmail.com </a> або за телефоном <a href={"tel:+380504489303"} style={{color: 'black',  fontWeight: 'normal'}}> 380504489303 </a>.</p>
                        <p>7.5. Організатор несе відповідальність за забезпечення конфіденційності та безпеки персональних даних Клієнта у межах, визначених чинним законодавством.</p>

                    </div>
                </div>
            </div>

            <footer className={style.footer}>
                <img src={contactCreeperImage} alt={'footer leafs'} className={style.leafsImageFooter} />
                <div className={style.mainFootersComponent}>
                    <img src={dinoLogo} alt="dyno-logo" className={style.logoImageFooter} />
                    <div className={style.footerLinksBlock}>
                        <div className={style.footerLinks}>
                            <a href="#payment-rules">
                                {paymentType === 'LiqPay' ? 'Умови і правила Оплати' : 'Rules for Payment'}
                            </a>
                            <a href="#delivery-rules">
                                {paymentType === 'LiqPay' ? 'Умови і правила Доставки' : 'Rules for Delivery'}
                            </a>
                            <a href="#refund-policy">
                                {paymentType === 'LiqPay' ? ' Умови і правила повернення коштів' : 'Refund Policy'}
                            </a>
                        </div>
                        <div className={style.footerLinks}>
                            <a href="#confidentiality-rules">
                                {paymentType === 'LiqPay' ? ' Умови Конфіденційності даних клієнта' : 'Rules for Confidential clients data'}
                            </a>
                            <a href="#about-us">
                                {paymentType === 'LiqPay' ? 'Про нас' : 'About Us'}
                            </a>
                            <a href={`${process.env.REACT_APP_API_URL}/public-offer`}>
                                {paymentType === 'LiqPay' ? 'Договір оферти' : 'Public Offer'}
                            </a>
                        </div>


                    </div>
                    <div className={style.block3}>
                        <a href={"tel:+380504489303"}> 380504489303 </a>
                        <a href={"email:dinoparkkyiv@gmail.com"}> dinoparkkyiv@gmail.com </a>
                        <div className={style.footerPaymentsBlock}>
                            <img src={liqpayImage} alt={'liqpay'} className={style.paymentImage}/>
                            <img src={cardsImage} alt={'visa'} className={style.paymentImage2} />
                        </div>
                    </div>
                </div>
                <div className={style.footerDown}>
                    <p> {paymentType === 'LiqPay' ? 'Всі права захищені DINO WORLD © 2022 - 2024' : 'All right reserved DINO WORLD © 2022 - 2024'}</p>
                    <p> {paymentType === 'LiqPay' ? 'САЙТ РОЗРОБЛЕНО: LexWeb Studio' : 'Developed By LexWeb Studio'}</p>

                </div>

            </footer>
            <button className={style.scrollToTop} onClick={handleScrollToTop}>
                ↑
            </button>
        </div>
    );
};

export default TicketEventPage;
